//@ts-check
import React from 'react';
import fieldLogic from '../logic/fieldsLogic';
import Buttons from '../controls/Buttons';

var FormButtons = function FormButtons(_ref) {
  var pageId = _ref.pageId,
      pages = _ref.pages,
      dispatch = _ref.dispatch,
      onSubmit = _ref.onSubmit,
      hideSubmitButton = _ref.hideSubmitButton,
      backButtonContent = _ref.backButtonContent,
      continueButtonContent = _ref.continueButtonContent,
      submitButtonContent = _ref.submitButtonContent,
      disableSubmitButton = _ref.disableSubmitButton;
  var pageIdx = pages.findIndex(function (page) {
    return page === pageId;
  });
  var showSubmit = !hideSubmitButton && pageIdx === pages.length - 1;
  var showBack = pageIdx != 0;
  var showNext = !showSubmit && pageIdx < pages.length - 1;

  var onPrevious = function onPrevious() {
    fieldLogic.onPageChange(pages[pageIdx - 1], dispatch);
  };

  var onNext = function onNext() {
    fieldLogic.onPageChange(pages[pageIdx + 1], dispatch);
  };

  var onSubmitClick = function onSubmitClick() {
    return onSubmit && onSubmit();
  };

  return React.createElement(Buttons, {
    showBack: showBack,
    showNext: showNext,
    showSubmit: showSubmit,
    onPrevious: onPrevious,
    onNext: onNext,
    onSubmit: onSubmitClick,
    pageNumber: pageIdx + 1,
    backButtonContent: backButtonContent,
    continueButtonContent: continueButtonContent,
    submitButtonContent: submitButtonContent,
    disableSubmitButton: disableSubmitButton
  });
};

export default React.memo(FormButtons);